import FormSelectBox from '@views/components/Inputs/FormSelectBox';
import { useGetTransportationGroupsList } from '@views/screens/common/hooks';
import { useGetShippingTransportationGroupsList } from '@views/screens/Shipment/hooks';
import i18n from 'i18next';

import { transportationGroupData } from '../../../Quote/constants.js';

export const TransportationGroupSelect = ({
  placeholder = i18n.t('translation:default.fields.transportationGroup.placeholder'),
  label = i18n.t('translation:default.fields.transportationGroup.label'),
  rules = [],
  name,
  editMode,
  onChange,
  defaultValue,
  isAllRequired = false,
  isMockData = false,
  disableValidation,
  dataTestId,
  isGroupShipping,
  isRequired,
}) => {
  const { data: options = [], isLoading } = isGroupShipping
    ? // biome-ignore lint/correctness/useHookAtTopLevel: <need refactor logic>
      useGetShippingTransportationGroupsList()
    : // biome-ignore lint/correctness/useHookAtTopLevel: <need refactor logic>
      useGetTransportationGroupsList();

  const labelValueData = transportationGroupData.map((item) => {
    return { label: item.value, value: item.id };
  });

  const selectOptions = isAllRequired ? [{ label: 'All', value: '' }, ...options] : options;

  return (
    <FormSelectBox
      loading={isLoading}
      options={isMockData ? labelValueData : selectOptions}
      placeholder={placeholder}
      label={label}
      isRequired={isRequired}
      rules={rules}
      defaultValue={defaultValue}
      name={name}
      editMode={editMode}
      onChange={onChange}
      disableValidation={disableValidation}
      dataTestId={dataTestId}
    />
  );
};
